import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import DeleteModel from "../../Components/DeleteModel";
import { deleteItem, submitForm, toggleStatus } from "../../utils/apiUtils";
import {
  ActionButton,
  PlusButton,
  SwitchToggle,
  ToggleSwitch,
} from "../../helper/ImageFormat";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Spinner from "../../Components/spinner";
import BackButton from "../../Components/BackButton";

const StitchingMeasurement = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [measurementdata, setmeasurementdata] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [updatedata, seutpdatedata] = useState();
  const [isDeleting, setIsDeleting] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    type: "",
    values: "",
    range: "",
  });
  const [data, setData] = useState({
    name: "",
    type: "",
    values: "",
    range: "",
    isActive: true
  });

  const handleEditClick = (item) => {
    setEditingId(item?.id);
    seutpdatedata(item);
    setModalOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      if (name === "type") {
        if (value === "Dropdown") {
          updatedData.range = "";
        } else if (value === "TextField") {
          updatedData.values = "";
        }
      }

      return updatedData;
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  useEffect(() => {
    if (updatedata) {
      setData({
        name: updatedata.name || "",
        type: updatedata.type || "",
        range: updatedata.range || "",
        values: updatedata.values || "",
        isActive: updatedata?.isActive ?? true,
      });
    }
  }, [updatedata]);

  const fetchmeasurementdata = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/option-measurement/${id}`);
      if (response?.status === 200) {
        const { data } = response?.data;
        setmeasurementdata(data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(true);
      let message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  useEffect(() => {
    fetchmeasurementdata();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setBtnLoading(true);
    try {

      let hasErrors = false;
      const requiredFields = [
        { name: "name", message: "Name is required" },
        { name: "type", message: "Type is required" },
      ];

      requiredFields.forEach((field) => {
        if (!data[field.name]) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [field.name]: field.message,
          }));
          hasErrors = true;
        }
      });

      if (data.type === "Dropdown" && !data.values) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          values: "Dropdown values are required",
        }));
        hasErrors = true;
      }

      if (data.type === "TextField" && !data.range) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          range: "Range is required for TextField",
        }));
        hasErrors = true;
      }

      if (hasErrors) return;
      data.option_id = id;

      if (data.type === "TextField") {
        delete data.values;
      } else {
        delete data.range;
      }

      await submitForm({
        data,
        url: "/option-measurement",
        editingId,
        validateFields: [],
        validationErrorsSetter: setErrors,
        onSuccess: () => fetchmeasurementdata(),
        closeModal: () => setModalOpen(false),
      });
    } catch (error) {
      return error
    } finally {
      setBtnLoading(false);

    }

  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };


  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("option-measurement", deleteItemId?.id, fetchmeasurementdata);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (err) {
      throw err;
    } finally {
      setIsDeleting(false);
    }
  };


  const handleStatusToggle = async (previousdata) => {
    const data = await toggleStatus(
      "option-measurement-status",
      previousdata?.id,
      previousdata?.isActive
    );
    if (Object.keys(data).length > 0) {
      setmeasurementdata((item) =>
        item.map((curr) =>
          curr.id === previousdata.id ? { ...curr, isActive: data?.isActive } : curr
        )
      );
    }
  };

  const handleAddLabels = () => {
    setData({ name: "", type: "", values: "", range: "" });
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setErrors({
      name: "",
      type: "",
      values: "",
      range: "",
    });
    setData({
      name: "",
      type: "",
      values: "",
      range: "",
    });
    setModalOpen(false);
  };

  const toggleModal = () => {
    setModalOpen((previous) => !previous);
    handleModalClose();
    setEditingId((previous) => null);
  };

const truncate = (str = "", maxLength = 50) => {
  if (typeof str !== "string") return "";
  return str.length > maxLength
    ? str.slice(0, maxLength) + "..."
    : str;
};
  const Tableheader = ["Name", "Type", "Range", "Values", "Is Active", "Action"];

  return (
    <>
      <div className="content-wrapper">
        <div
          className="page-header mt-5"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h3 className="custom-page-title">Stitching Measurements</h3>
        </div>

        <div
          style={{
            background: "#fff",
            padding: "10px",
            marginTop: "-20px",
            display: "flex",
            justifyContent: "flex-end",
            gap:"20px"
          }}
        >
          <BackButton/>
          <PlusButton handleAdd={handleAddLabels} module={"stitching measurement"} />
        </div>

        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <table
                  className=" custom-table table table-striped"
                  id="testimonialtable"
                >
                  <thead>
                    <tr>
                      {Tableheader.map((item, index) => (
                        <th className="font-weight-bold" key={index}>
                          {item}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <Spinner />
                        </td>
                      </tr>
                    ) : measurementdata.length > 0 ? (
                      measurementdata.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.name}</td>
                          <td>{item?.type}</td>
                          <td >{item?.range}</td>
                         <td title={item?.values || "--"}>
  {item?.values ? truncate(item.values, 80) : "--"}
</td>



                          <td>
                            <ToggleSwitch
                              data={item}
                              name="isActive"
                              checked={item.isActive}
                              handleStatusToggle={handleStatusToggle}
                              module={"stitching measurement"}
                            />
                          </td>
                          <td className="text-center">
                            <ActionButton
                              data={item}
                              handleEditClick={handleEditClick}
                              handleDelete={handleDelete}
                              module={"stitching measurement"}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <h4>No data available</h4>
                        </td>
                      </tr>
                    )}
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        centered
        className="white-modal"
      >
        <ModalHeader toggle={toggleModal} className="close-currency">
          {editingId ? "Update" : "Add"} Stitching Measurement
        </ModalHeader>
        <form onSubmit={handleSubmit}>
          <ModalBody className="currency">
            <div className="mb-3">
              <select
                className="form-control form-control-sm "
                id="type"
                name="type"
                defaultValue=""
                value={data?.type}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Field Type
                </option>
                <option value="TextField">TextField</option>
                <option value="Dropdown">Dropdown</option>
              </select>
              {errors.type && <small className="text-danger">{errors.type}</small>}
            </div>

            <div className="mb-3">
              <input
                type="text"
                className="form-control form-control-sm border border-dark"
                id="name"
                name="name"
                placeholder="Enter name"
                value={data.name}
                onChange={handleChange}
              />
              {errors.name && <small className="text-danger">{errors.name}</small>}
            </div>

            {data.type === "Dropdown" && (
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm border border-dark"
                  id="values"
                  name="values"
                  placeholder="Enter values (comma-separated)"
                  value={data.values}
                  onChange={handleChange}
                />
                {errors.values && (
                  <small className="text-danger">{errors.values}</small>
                )}
              </div>
            )}

            {data.type === "TextField" && (
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="range"
                  name="range"
                  placeholder="Enter range (1-20)"
                  value={data.range}
                  onChange={handleChange}
                />
                {errors.range && <small className="text-danger">{errors.range}</small>}
              </div>
            )}

            <div className="col-md-12 mt-4 p-0" >
              <SwitchToggle
                checked={data.isActive}
                onChange={(val) => setData((prev) => ({ ...prev, isActive: val }))}
              />
            </div>

          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={btnLoading}>
              {btnLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin me-2" />
                  {editingId ? "Updating..." : "Adding..."}
                </>
              ) : editingId ? (
                "Update"
              ) : (
                "Add"
              )}
            </Button>
            <Button color="btn btn-danger" onClick={toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </Modal>
      <DeleteModel
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
        onConfirm={confirmDelete}
        itemName="Measurement"
        isDeleting={isDeleting}
      />
    </>
  );
};

export default StitchingMeasurement;
